import { memo } from 'react';

import { DurationProps } from './Duration.types';
import { format } from './Duration.utils';

export const Duration = memo(({ seconds }: DurationProps) => {
  return <time dateTime={`P${Math.round(seconds)}S`}>{format(seconds)}</time>;
});
